// Itinerary language helpers — the Appearance → Language dropdown options and
// the day-summary code→name lookup. Both derive from the canonical language
// metadata in `@travel-planner/shared/schemas` (the single source of truth for
// the 23 supported languages, their names, and ordering) so this domain keeps
// no language list of its own.

import { languageName } from '@travel-planner/shared/schemas';
import { languageCodeValues } from '@travel-planner/shared/schemas/facility';

// Case-insensitive language-code → English display name. Falls back to the raw
// code when unknown so day summaries never render blank.
export const getLanguageName = (
  code: string | null | undefined
): string | null => {
  if (!code) return null;
  return languageName(code);
};

// Dropdown options for the itinerary Language select — lowercase code as the
// stored value, English exonym as the label (V2 parity). Mutable array because
// the shared `Select` `options` prop is non-readonly.
export const LANGUAGE_SELECT_OPTIONS: { value: string; label: string }[] =
  languageCodeValues.map((code) => ({
    value: code,
    label: languageName(code),
  }));
